import classNames from "classnames";
import PageContent from "../PageContentFactory/component";
import { getSectionTrackingClass } from "../../utils/library.js";
import { SectionContainer } from "../SectionContainer/component";

import getSections from "./utils";
import { POSITION_MAIN, POSITION_RIGHT } from "../../../../constants/page";
import {
    SECTION_LAYOUT_CLASS_NAMES,
    WITH_RIGHT_RAIL_CLASS_NAME,
} from "../../constants";
import SectionMain from "../../../../components/SectionMain/component";
import SectionRight from "../../../../components/SectionRight/component";

const SectionContent = ({ content, index, position, ...props }) => {
    return content?.map((current, idx) => (
        <PageContent
            key={`${current.type}-${idx}`}
            type={current.type}
            params={current}
            position={position}
            sectionIndex={index}
            contentIndex={idx}
            {...props}
        />
    ));
};

const Section = ({ section, index, viewport, isNativeAd }) => {
    const [main, right] = section;
    const sectionLayoutClassNames =
        SECTION_LAYOUT_CLASS_NAMES.get(section[0]?.layout) !== "undefined"
            ? SECTION_LAYOUT_CLASS_NAMES.get(section[0]?.layout)
            : "";

    const classes = classNames(
        sectionLayoutClassNames,
        right?.content?.length && WITH_RIGHT_RAIL_CLASS_NAME,
        getSectionTrackingClass(index)
    );

    const props = {
        index,
        right,
        viewport,
        isNativeAd,
    };

    const rightInnerClasses = {
        className: "sidebar contentArea",
    };

    return (
        <SectionContainer className={classes}>
            {main.content[0] && (
                <SectionMain>
                    <SectionContent
                        content={main.content}
                        position={POSITION_MAIN}
                        sectionHasRightRail={right?.content?.[0]}
                        {...props}
                    />
                </SectionMain>
            )}
            {right.content[0] && (
                <SectionRight>
                    <div {...rightInnerClasses}>
                        <SectionContent
                            content={right.content}
                            position={POSITION_RIGHT}
                            {...props}
                        />
                    </div>
                </SectionRight>
            )}
        </SectionContainer>
    );
};

export const Sections = (props) => {
    const sections = getSections(props?.page);
    return sections?.map((section, idx) => (
        <Section key={idx} section={section} index={idx} {...props} />
    ));
};
